/*
  video-scroll.js — shared scroll-autoplay controller for Ergoliv "Bold" sections.

  Targets ANY <video data-video-scroll> on the page (video band S4, assembly
  slot S5, future modules). Plays when it scrolls into view, pauses on exit.

  Mechanics (matches the design prototype's debugged fix):
    - NEVER uses the `autoplay` attribute (that's the codec/promise pitfall).
    - On intersect: video.muted = true; video.play().catch(() => {}).
    - On exit:      video.pause().
    - IntersectionObserver threshold 0.25.
    - Respects prefers-reduced-motion: gated videos are left paused on their
      poster (the merchant can still hit the native controls if present).

  One shared observer for the whole page; videos register themselves lazily
  (covers Section Rendering API re-renders and theme-editor block adds).
*/
(function () {
  if (window.__ergolivVideoScroll) return;

  var REDUCED = false;
  try {
    REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {
    REDUCED = false;
  }

  var supported = typeof IntersectionObserver !== 'undefined';

  function play(video) {
    try {
      video.muted = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    } catch (e) {
      /* play() can throw synchronously on detached nodes — ignore */
    }
  }

  function pause(video) {
    try {
      video.pause();
    } catch (e) {
      /* ignore */
    }
  }

  var observer = supported
    ? new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              play(video);
            } else {
              pause(video);
            }
          });
        },
        { threshold: 0.25 }
      )
    : null;

  function register(video) {
    if (!video || video.__videoScrollBound) return;
    video.__videoScrollBound = true;

    // Reduced motion: never auto-play. Leave the poster visible.
    if (REDUCED) return;

    if (observer) {
      observer.observe(video);
    } else {
      // No IO support — fall back to playing immediately (still muted).
      play(video);
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll('video[data-video-scroll]');
    for (var i = 0; i < nodes.length; i++) register(nodes[i]);
  }

  var controller = {
    register: register,
    scan: scan,
  };
  window.__ergolivVideoScroll = controller;

  // Initial sweep.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }

  // Theme editor: re-scan when a section/block is added or re-rendered so a
  // newly inserted video band starts autoplaying without a reload.
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      scan(event.target || document);
    });
    document.addEventListener('shopify:block:select', function (event) {
      scan(event.target || document);
    });
  }
})();
